import { createSelector, Selector } from "@ngxs/store";
import { VariablesState, VariablesStateModel } from "./variables.state";

export class VariablesGetterState {
  @Selector([VariablesState])
  static getVariablesTree(state: VariablesStateModel) {
    return state.ids.map(id => state.entities[id]);
  } 

  @Selector([VariablesState])
  static getVariableInstruction(state: VariablesStateModel) {
    return state.variableInstruction;
  }

  @Selector([VariablesState])
  static getVariableValuesSearchResults(state: VariablesStateModel) {
    return state.variableValuesSearchResults;
  }

  @Selector([VariablesState])
  static getFlatVariables(state: VariablesStateModel) {
    return state.flatVariablesList;
  }

  @Selector([VariablesState])
  static getTagInfo(state: VariablesStateModel) {
    return state.tagInfo;
  }

  @Selector([VariablesState])
  static getSearchResults(state: VariablesStateModel) {
    return state.searchResults;
  }

  static getFlatVariable(tag: string) {
    return createSelector([VariablesState], (state: VariablesStateModel) => {
      return state.flatVariablesList[tag];
    })
  }

  @Selector([VariablesState])
  static getSearchedVariableSubTree(state: VariablesStateModel) {
    return state.searchSubTreeResults;
  }

  @Selector([VariablesState])
  static getVariablesPresetList(state: VariablesStateModel) {
    return state.variablesPresetList;
  }

  @Selector([VariablesState])
  static getVariablesPreset(state: VariablesStateModel) {
    return {name: state.variablesPresetName, preset: state.variablesPreset};
  }
}
